/**
 * planeColors - Single source of truth for axial/coronal/sagittal plane colors.
 *
 * Used by:
 *  - SegmentationViewer3D.tsx (three.js LineBasicMaterial color, RGB number)
 *  - SegmentationViewerPanel.tsx (CSS legend swatches, hex string)
 *  - Any other component that needs to color-code by anatomical plane.
 *
 * Keep these synchronized — changing the blue/green/red elsewhere is a bug.
 */

export type PlaneKey = "axial" | "coronal" | "sagittal";

/** Three.js / numeric form (used by THREE.LineBasicMaterial.color etc). */
export const PLANE_COLORS: Record<PlaneKey, number> = {
  axial: 0x60a5fa,
  coronal: 0x4ade80,
  sagittal: 0xf87171,
};

/** CSS / hex string form (used in JSX style props and CSS). Same RGB values. */
export const PLANE_COLORS_HEX: Record<PlaneKey, string> = {
  axial: "#60a5fa",
  coronal: "#4ade80",
  sagittal: "#f87171",
};
